export const TAB_IDS = {
  PORTALS: "portals",
  PAGES: "pages"
};
